export function convertStringArrToNumberArr(arr: string[]): number[] {
  return arr.map((value) => +value).filter((value) => !Number.isNaN(value));
}
